module.exports = __webpack_public_path__ + "img/screen-frame.151f65d0.jpg";